import {
  Select as CarbonSelect,
  SelectSkeleton as CarbonSelectSkeleton,
  SelectItem,
  SelectItemGroup,
} from "@carbon/react";

import { InfoIcon } from "../../components";

export const View = (props) => {
  const {
    selectItems,
    selectGroupedItems = [],
    placeholder = "Choose an option",
    showSkeleton,
    hideSkeletonLabel,
    infoIconText,
    containerClassName,
    ...rest
  } = props;

  return (
    <div className={`${containerClassName}`}>
      {showSkeleton && !props.disabled ? (
        <CarbonSelectSkeleton {...rest} hideLabel={hideSkeletonLabel} />
      ) : (
        <CarbonSelect
          // helperText={props.helperText}
          // placeholder={props.placeholder}
          {...rest}
          id={props.name}
          labelText={
            !props.label && !infoIconText ? null : (
              <div className="flex-container">
                <div className="flex-box">{props.label} </div>
                {infoIconText ? (
                  <div className="ml-3">
                    <InfoIcon message={infoIconText} />{" "}
                  </div>
                ) : null}
              </div>
            )
          }
          className={`${props.className} switchapp-themed`}
        >
          <SelectItem
            disabled
            text={placeholder}
            // value="placeholder-item"
          />

          {selectGroupedItems.map((itemGroup, i) => (
            <SelectItemGroup
              key={`${itemGroup.groupLabel}_${i}`}
              label={itemGroup.groupLabel}
            >
              {itemGroup.options.map((option, optionIndex) => {
                return (
                  <SelectItem
                    key={`${option.value}_${optionIndex}`}
                    text={option.text}
                    value={option.value}
                  />
                );
              })}
            </SelectItemGroup>
          ))}

          {selectItems.map((item, i) => (
            <SelectItem
              key={`${item.value}_${i}`}
              text={item.text}
              value={item.value}
            />
          ))}
        </CarbonSelect>
      )}
    </div>
  );
};
